<div class="flex flex-col gap-4">
  @if (isEditable()) {
    <app-document-upload-card
      [title]="'common.referenceDocument' | transloco"
      [subtitle]="
        'provider.tenderResponse.projectReferences.referenceDocument.subtitle' | transloco
      "
      tooltipKey="provider.tenderResponse.projectReferences.referenceDocument"
      [hint]="'project.steps.rfq.invitationPreview.file.hint' | transloco"
      [isSingleDocument]="true"
      [documents]="documentItems()"
      (uploadDocument)="onUpload($event)"
      (previewDocument)="onPreview()"
      (downloadDocument)="onDownload()"
      (editDocument)="onEdit($event)"
      (deleteDocument)="onRemove()"
    />
  }

  <app-model-field-textarea
    [id]="'project-reference-document-summary-' + position()"
    label="project.steps.summary"
    tooltipKey="provider.tenderResponse.projectReferences.documentSummary"
    [isRequired]="isSummaryRequired()"
    [isReadOnly]="readOnly()"
    [(value)]="documentSummary"
  />

  @if (canSummarise()) {
    <div class="flex justify-end">
      <p-button
        [label]="'provider.tenderResponse.projectReferences.summarise' | transloco"
        icon="pi pi-sparkles"
        [attr.data-testid]="'project-reference-summarise-' + position()"
        [disabled]="isSummarising()"
        [loading]="isSummarising()"
        (onClick)="onSummarise()"
      />
    </div>
  }

  <app-language-select-dialog
    [(visible)]="isLanguageDialogVisible"
    (languageSelected)="onLanguageSelected($event)"
  />
</div>
